
$(document).ready(function () {
    $('.menu-box').click(function (e) {
        e.stopPropagation();
        $(this).find(".hamburger-menu-x").toggleClass('active');
        $("#main-menu").toggleClass('active');
        $('.overlay-menu').toggleClass('active');
        if ($("#main-menu").hasClass("active")) {
            $('header').addClass("header-scroll");
        } else if (window.pageYOffset <= 150) {
            $('header').removeClass("header-scroll");
        }
    });

    $('.overlay-menu').click(function (e) {
        if ($("#main-menu").hasClass("active")) {
            $(".hamburger-menu-x").removeClass('active');
            $("#main-menu").removeClass('active');
        }
        $(this).removeClass('active');
    });

    $('.icon-close').click(function (e) {
        $(".main-search").toggleClass('active');
    });

    $('.icon-search, .btn-search').click(function (e) {
        var keyword = $("#keyword").val();
        // var isSearchActive = $(".main-search").hasClass('active');
        // if (keyword && isSearchActive) {
        if (keyword) {
            var slug = $("#slug").val();
            var type = $("#type").val();
            if (type != "" && slug != "" & keyword != "") {
                if (slug.indexOf("_color_") != -1) {
                    var repSlug = slug.replace('_color_', '/');
                    var color = repSlug.split('/')[1];
                    var newSlug = repSlug.split('/')[0];
                    window.location = '/tim-kiem?keyword=' + keyword.replace('%20', '+').replace(' ', '+') + '&slug=' + newSlug + '&color=' + color + '&type=' + type;
                }
                else {
                    window.location = '/tim-kiem?keyword=' + keyword.replace('%20', '+').replace(' ', '+') + '&slug=' + slug + '&type=' + type;
                }
            }
            else {
                window.location = '/tim-kiem?keyword=' + keyword.replace('%20', '+').replace(' ', '+') + '&slug=empty&type=0';
            }
        }
        //  else {
        //     $(".main-search").toggleClass('active');
        // }
    });
})